import { render } from "./UserManagementForm.vue?vue&type=template&id=66c14ce4"
import script from "./js/userManagementForm.js?vue&type=script&lang=js&external"
export * from "./js/userManagementForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__